import { render, staticRenderFns } from "./TheHeaderArea.vue?vue&type=template&id=28edcd56&scoped=true"
import script from "./TheHeaderArea.vue?vue&type=script&lang=js"
export * from "./TheHeaderArea.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderArea.vue?vue&type=style&index=0&id=28edcd56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edcd56",
  null
  
)

export default component.exports